const BaseCategoryPage = require('base/category-page');
const { getDistrictTree } = require('helper/server');
const { walkNoTextTree, selectTreeDefault } = require('helper/util');
const { catalogCode } = require('helper/config');
const Server = require('helper/server');

const searchlTpl = Handlebars.templates['templates/search-tpl'];
const advancedSearchlTpl = Handlebars.templates['templates/advanced-search-tpl'];
let catalogId = null; // 采购目录分类id
class SearchOnline extends BaseCategoryPage {
  search () {
    this.$content.find('.block__content').spin(); // 搜索前先旋转
    const { code, showContent, fullName } = this.selectedTreeNode;
    const { articleId, PID } = this.query.params;
    if (showContent && this.previewFlag) {
      this.renderPreview({ categoryCode: code, articleId, PID });
    } else if (showContent) {
      this.renderDetail({ categoryCode: code });
    } else if (fullName) { // 树信息中有fullName的是采购目录
      const { districtCode = code, year = new Date().getFullYear() } = this.query.params;
      const payload = { districtCode, year };
      this.renderCatalog(payload, this.query.params);
    } else {
      let payload = {
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        categoryCode: code
      };
      $.extend(payload, this.query.params);
      // this.client
      //   .searchArticleByKeyWord(payload)
      //   .done((...res) => this.renderList(...res));
      Server.searchCategory(payload).then((res) => {
        console.log(res);
        this.renderList(res);
      });
    }
  }

  selectTreeNode (e, { instance }) {
    this.renderBreadcrumb(instance);
    this.initSearchPanel();
    this.$content.find('.block__content').spin();
    this.search();
  }

  advancedSearch () {
    if (!this.$asModal) {
      const year = []; // 年份
      const currentYear = new Date().getFullYear();
      for (let i = currentYear; i > 2014; i--) {
        year.push(i);
      }
      const data = { year };
      this.$asModal = ZCY.utils.modal({
        templateUrl: 'templates/catalog-as-modal-tpl',
        container: this.$el,
        data,
        cls: 'as-modal',
        button: ['查询', '重置'],
        cancel: ($modal) => {
          $modal.emptyData();
          this.query.empty();
        },
        confirm: ($modal) => {
          $modal.modal('hide');
          const param = $modal.getData();
          this.query.empty();
          for (let k in param) {
            this.query.set(k, param[k]);
          }
          this.searchEvent({ type: 'as' });
        }
      }).modal;
    } else {
      this.$asModal.modal('show');
    }
  }

  initSearchPanel () {
    const { fullName } = this.selectedTreeNode;
    const { showContent = false } = this.selectedTreeNode;
    if (showContent) {
      this.$searchPanel.html('');
    } else if (fullName) { // 树信息中有fullName的是采购目录
      this.$searchPanel.html(advancedSearchlTpl);
    } else {
      this.$searchPanel.html(searchlTpl);
    }
  }

  // 菜单tree数据封装
  async treeData () {
    let { data } = await getDistrictTree();
    const tree = super.treeData();
    const catalog = tree.children.find((item) => {
      if (item.code === catalogCode) {
        catalogId = String(item.id);
        return true;
      }
      return false;
    });
    // 返回的是采购目录选中时默认选中采购目录下第一个叶子节点
    if (catalog.selected) {
      catalog.selected = false;
      selectTreeDefault(data);
    }
    catalog.children = walkNoTextTree(data);
    return tree;
  }

  conditionalselect ({ original: { id }, parents, children }) {
    // 采购目录下只有叶子节点可选中
    if (this.previewFlag || id == catalogId || parents.includes(catalogId) && children.length > 0) {
      return false;
    }
    return true;
  }
}

module.exports = SearchOnline;

